import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'

async function bootstrap() {
  try {
    // Try IP-based geolocation
    const res = await fetch('https://ipwho.is/');
    const data = await res.json();
    (window as any).__USER_COUNTRY__ = data.country_code;
  } catch {
    (window as any).__USER_COUNTRY__ = null;
  }

  //import i18n AFTER country is set
  await import('./locales/i18n');

  const App = (await import('./App')).default;

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();